// Keepalive helpers for Phase 2 Deepgram streaming robustness.
// See docs/planning/deepgram_streaming_robustness.md §3 Phase 2.

/** Poll interval for the keepalive timer in `deepgramStreamingEngine.ts`. */
export const KEEPALIVE_INTERVAL_MS = 10_000;

/** Send KeepAlive when no successful PCM frame was sent in this window. */
export const KEEPALIVE_SILENCE_THRESHOLD_MS = 5_000;

export const DEEPGRAM_KEEPALIVE_JSON = JSON.stringify({ type: "KeepAlive" });

export function shouldSendKeepAlive(
  lastPcmSentAtMs: number,
  nowMs: number,
  silenceThresholdMs = KEEPALIVE_SILENCE_THRESHOLD_MS,
): boolean {
  return nowMs - lastPcmSentAtMs >= silenceThresholdMs;
}

export type KeepaliveTimerHandle = {
  start(): void;
  stop(): void;
};

/** Interval timer wrapper so the engine can clear keepalive on stop/destroy. */
export function createKeepaliveTimer(
  onTick: () => void,
  intervalMs = KEEPALIVE_INTERVAL_MS,
): KeepaliveTimerHandle {
  let timerId: ReturnType<typeof setInterval> | null = null;
  return {
    start() {
      if (timerId != null) return;
      timerId = setInterval(onTick, intervalMs);
    },
    stop() {
      if (timerId == null) return;
      clearInterval(timerId);
      timerId = null;
    },
  };
}
